// extracted by mini-css-extract-plugin
export var actionText = "_o8-4";
export var container = "_o8-0";
export var leftSection = "_o8-1";
export var rightSection = "_o8-2";
export var settingsButton = "_o8-6";
export var settingsIcon = "_o8-7";
export var shortcut = "_o8-5";
export var shortcutGroup = "_o8-3";